/* __next_internal_client_entry_do_not_use__ default auto */ import systemUseThemeProps from '@mui/system/useThemeProps';
import defaultTheme from "./defaultTheme.js";
import THEME_ID from "./identifier.js";
export default function useThemeProps(param) {
    let { props, name } = param;
    return systemUseThemeProps({
        props,
        name,
        defaultTheme,
        themeId: THEME_ID
    });
}
